import { useToast } from "modules/navbar/top/store/toasterStore";
import React from "react";
import { Button, Form } from "react-bootstrap";

function SearchForm({
  setSearchQuery,
  searchQuery,
  handleSearch,
  handleClear,
}) {
  const { setToaster } = useToast();
  const handleSearchInputChange = (event) => {
    if (event.target.value.startsWith("#") || event.target.value === "") {
      setSearchQuery(event.target.value);
    } else {
      setToaster("Id","Id should start with #","danger")
    }
  };
  return (
    <div className="flex-1 p-3">
      <Form
        className="d-flex  flex-row gap-1"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div className="form-group mt-n1 flex-fill">
          <label>
            {" "}
            <span className="red-star text-danger ">*</span> Order ID
          </label>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              id="orderID"
              placeholder="Enter Order ID"
              value={searchQuery}
              onChange={handleSearchInputChange}
              required
            />
          </div>
        </div>
        <Button
          variant="primary"
          className="me-1 mt-4"
          onClick={handleSearch}
          style={{ height: "2.2rem" }}
        >
          Search
        </Button>
        <Button
          variant="primary"
          className="me-1 mt-4"
          onClick={handleClear}
          style={{ height: "2.2rem" }}
        >
          Clear
        </Button>
      </Form>
    </div>
  );
}

export default SearchForm;
